"use client";

import { ILayout } from "@/types/common";
import { Container } from "@mui/material";
import React from "react";

const Layout: React.FC<ILayout> = ({ children }) => {
  return (
    <Container maxWidth="lg" className="w-full h-auto mx-auto px-6 pt-12 pb-24">
      {children}
    </Container>
  );
};

export default Layout;
